import request from '@/utils/request';

export async function distributionStrategySendSms() {
  return request.post(`/distribution-strategy-send-sms`);
}

export async function distributionStrategyValidatorPhone() {
  return request.get(`/distribution-strategy-validator-phone`);
}
